module.exports = __webpack_public_path__ + "img/CSGO500.4b57d8bf.svg";